import InstituteCard from "../../components/InstituteCard/InstituteCard";
import Radar from "./Radar";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useEffect, useState } from "react";
import { stateWiseData } from "../../data/stateWiseData";
import { useNavigate } from "react-router";
import axios from "axios";
import { baseUrl } from "../../utils/api";
import topYoutuberCategories from "../../data/topYoutubeCategories.json";

const RadarScreen = ({ userInputs, uid, desktopView }) => {
  const [insititutes, setInstitues] = useState([]);
  const navigate = useNavigate();

  const handleClick = async () => {
    try {
      await axios.patch(`${baseUrl}/growth/saveDetails`, {
        submitted: true,
        uuid: uid,
      });
      navigate("/ThankYou");
    } catch (err) {
      console.log(err.message);
    }
  };

  useEffect(() => {
    let data = [];
    if (userInputs["youtuber-name"] || userInputs["online-course-name"]) {
      data = topYoutuberCategories.filter(
        (item) => item.category === userInputs["youtuber-categories"]
      );
      setInstitues(data);
    } else {
      data = stateWiseData.filter((item) => item.State === userInputs["state"]);
      setInstitues(data);
    }
  }, [userInputs]);

  const settings = {
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    cssEase: "linear",
    adaptiveHeight: true,
  };

  return (
    <div className={desktopView ? "mt-10" : ""}>
      {/* <img width="100%" src={Radar} /> */}
      {desktopView ? (
        <p className="text-colorHeading text-4xl">
          These are the top {insititutes.length}{" "}
          {userInputs["youtuber-name"]
            ? "content creators in your category"
            : "educators in your region"}
        </p>
      ) : (
        ""
      )}

      <div className="mt-5">
        <Radar />
      </div>

      <div className="mt-5">
        <Slider {...settings}>
          {insititutes.map((item, index) => (
            <div key={index}>
              <InstituteCard item={item} />
            </div>
          ))}
        </Slider>
      </div>

      {desktopView ? (
        <div className="mx-auto w-1/2">
          <button
            onClick={handleClick}
            className="mt-10 bg-colorSecondary text-colorWhite px-4 py-3 rounded w-full mx-auto"
          >
            Check more Teacherpreneurs
          </button>
        </div>
      ) : (
        <button
          onClick={handleClick}
          className="mt-10 bg-colorSecondary text-colorWhite px-4 py-3 w-full rounded"
        >
          Check more Teacherpreneurs
        </button>
      )}
    </div>
  );
};

export default RadarScreen;
